/**
 * UrnWorth cart sync.
 *
 * Keeps a product and its engraving fee line item in sync in the cart:
 * removing the main product also removes any fee line(s) immediately
 * following it. Relies on window.uwFeeProductHandles (set in theme.liquid
 * from the "urnworth-fees" collection) to identify which cart lines are
 * fee products versus regular products.
 *
 * If window.uwFeeProductHandles is empty (no fee products configured yet),
 * this does nothing and Dawn's default remove-button behavior runs as normal.
 */
(function () {
  function isFeeItem(item) {
    return !!(window.uwFeeProductHandles && window.uwFeeProductHandles.indexOf(item.handle) !== -1);
  }

  function getFollowingFeeKeys(items, index) {
    var keys = [];
    for (var j = index + 1; j < items.length; j++) {
      if (isFeeItem(items[j])) {
        keys.push(items[j].key);
      } else {
        break;
      }
    }
    return keys;
  }

  function refreshDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      drawer.renderContents(data);
    } else {
      window.location.reload();
    }
  }

  function removeLineAndLinkedFees(index) {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var items = cart.items;
        var idx = parseInt(index, 10) - 1;
        if (idx < 0 || idx >= items.length) return Promise.resolve();

        var clicked = items[idx];
        var updates = {};
        updates[clicked.key] = 0;

        if (!isFeeItem(clicked)) {
          getFollowingFeeKeys(items, idx).forEach(function (key) {
            updates[key] = 0;
          });
        }

        var drawer = document.querySelector('cart-drawer');
        var body = { updates: updates };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) {
            return s.id;
          });
          body.sections_url = window.location.pathname;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            return res.json();
          })
          .then(refreshDrawer);
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('cart-remove-button');
      if (!btn) return;
      if (!window.uwFeeProductHandles || !window.uwFeeProductHandles.length) return; // nothing configured yet

      e.preventDefault();
      e.stopImmediatePropagation();

      removeLineAndLinkedFees(btn.dataset.index).catch(function (err) {
        console.error('UrnWorth cart sync error:', err);
        window.location.reload();
      });
    },
    true // capture phase: run before Dawn's own remove-button handler
  );
})();
